module.exports = new __parcel__URL__("wbd-favicon-192.a6c8d36a.png").toString();